<template>
	<div class="midlle">
		<div class="myProject">

			<div class="midlle-body">
				<div class="body-title">
					<div class="line"></div>
					<div style="margin-left: 20px;">已创建的岗位</div>
				</div>
				<div class="select">
					<el-select v-model="adminValue" placeholder="请选择" @change="getPositionList">
						<el-option v-for="item in DepartmentList" :key="item.id" :label="item.name"
							:value="item.id">
						</el-option>
					</el-select>
				</div>
				<el-table :data="positionList" stripe style="width: 100%" border="">
					<el-table-column prop="id" label="岗位号" width="154" :resizable="false">
					</el-table-column>
					<el-table-column prop="name" label="岗位描述" width="168" :resizable="false">

					</el-table-column>
					<!-- <el-table-column label="岗位历程" width="154" :resizable="false">
						<template slot-scope="scope">
							<p>查看详情</p>
						</template>
					</el-table-column> -->
					<el-table-column label="当前状态" width="176" :resizable="false">
						<template slot-scope="scope">
							<p v-if="scope.row.status == 1">
								<span>正常</span> <span style="margin:6px">|</span>
								<span style="cursor: pointer;" @click.stop="changeStatus(scope.row)">更改</span>
							</p>
							<p v-if="scope.row.status == 0">
								<span>停止</span> <span style="margin:6px;">|</span>
								<span style="cursor: pointer;" @click.stop="changeStatus(scope.row)">更改</span>
							</p>
						</template>
					</el-table-column>
					<el-table-column label="员工" width="170" :resizable="false">
						<template slot-scope="scope">
							<p>
								<span>{{scope.row.user_name}}</span>
								
							</p>
						</template>
					</el-table-column>
					<el-table-column label="绑定与解绑" width="170" :resizable="false">
						<template slot-scope="scope">
							<p v-if="scope.row.user_id == null" style="cursor: pointer;" @click='goInviUser(scope.row)'>未绑定</p>
							<p v-else style="color: #0052d9;cursor: pointer;" @click="delUserFromJob(scope.row)">解绑</p>
						</template>
					</el-table-column>



				</el-table>
				<div class="addCompany" @click="addNew = true">
					+新建岗位
				</div>
				<el-dialog :lock-scroll='false' title="修改部门状态" :visible.sync="statusDialogVisible" width="400px" center>
					<div style="display: flex;justify-content: center;padding: 25px;">
						<el-select v-model="statusValue" placeholder="请选择">
							<el-option v-for="item in statusOptions" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
						
					</div>
					<span slot="footer" class="dialog-footer">
						<el-button @click="statusDialogVisible = false">取 消</el-button>
						<el-button style="background: #0052d9;" type="primary" @click="statusConfirm">确 定</el-button>
					</span>
				</el-dialog>
				<el-dialog :lock-scroll='false' title="邀请用户" :visible.sync="userDialogVisible" width="500px" center>
					<div style="display: flex;justify-content: center;padding: 25px;flex-wrap: wrap;">
						<el-select v-model="userValue" filterable placeholder="请选择">
							<el-option v-for="item in adminOptions" :key="item.id" :label="item.nickname"
								:value="item.id">
							</el-option>
						</el-select>
						<div style="width: 90%;margin-top: 20px;">
							<!-- <input type="textarea" :rows="2" type="text" v-model="inviteMsg" placeholder="请输入邀请留言"/> -->
							<el-input
							  type="textarea"
							  :rows="4"
							  placeholder="邀请信息"
							  v-model="inviteMsg">
							</el-input>
						</div>
					</div>
					<span slot="footer" class="dialog-footer">
						<el-button @click="adminDialogVisible = false">取 消</el-button>
						<el-button style="background: #0052d9;" type="primary" @click="inviteUserWork">确 定</el-button>
					</span>
				</el-dialog>
				<el-dialog :lock-scroll='false' title="新增岗位" :visible.sync="addNew" width="700px" center>
					<div style="display: flex;justify-content: center;padding: 25px;flex-wrap: wrap;">
						<div class="form-item">
							<div class="form-item-title">
								<div>岗位名称</div>
								<span>:</span>
							</div>
							<div class="inp">
								<input type="text" v-model="addNewDepart.name" placeholder="请输入岗位名称">
							</div>
						</div>
				<!-- 		<div class="form-item">
							<div class="form-item-title">
								<div>员工</div>
								<span>:</span>
							</div>
							<div class="inp">
								<input type="text" v-model="form.yuanG" placeholder="请输员工姓名">
							</div>
						</div> -->
					</div>
					<span slot="footer" class="dialog-footer">
						<el-button @click="addNew = false">取 消</el-button>
						<el-button style="background: #0052d9;" type="primary" @click="confirmAdd">确 定</el-button>
					</span>
				</el-dialog>
			</div>
		</div>
	</div>
</template>

<script>
	import isEmpty from '../../utils/isEmpty.js'
	export default {
		data() {
			return {
				groupInfo:[],
				addNew: false,
				statusDialogVisible: false,
				adminDialogVisible: false,
				userDialogVisible:false,
				tableData3: [{
					BH: '8946',
					name: '销售',
					status: 1,
					yuanG: '杜威',
					id: 8,
					BD: 1
				}],
				statusOptions: [{
					value: 0,
					label: '停止'
				}, {
					value: 1,
					label: '正常'
				}],
				statusValue: '',
				statusID: '',
				adminOptions: [{
					id: 6,
					label: '小李'
				}, {
					id: 1,
					label: '小王'
				}],
				adminValue: '',
				userValue:'',
				adminID: '',
				form: {
					yuanG: '',
					name: ''
				},
				DepartmentList:[],
				addNewDepart:{
					type:2,
					department_id:'',
					name:'',
				},
				positionList:[],
				userList:[],
				inviteMsg:'',
				inviteUserID:''
			}
		},
		created() {
			const groupInfoString = sessionStorage.getItem('groupInfo');
			if (groupInfoString) {  
			  this.groupInfo = JSON.parse(groupInfoString);  
			} else {  
			  // 处理未找到 groupInfo 的情况，可能设置为 null 或其他默认值  
			  this.groupInfo = null;  
			}  
			this.getPositionList()
			this.getDepartmentList()
			this.getUserLists()
		},
		methods: {
			goInviUser(e){
				// console.log(e);
				this.inviteUserID = e.id
				this.userDialogVisible = true
			},
			async inviteUserWork(){
				const invite = await this.$api.inviteUserComeWork({job_id:this.inviteUserID,user_id:this.userValue,msg:this.inviteMsg})
				if(invite.code == 1){
					this.$message({
						message:invite.msg,
						type:'success'
					})
					this.userDialogVisible = false
					this.getPositionList()
					this.inviteUserID = ''
					this.userValue = ''
					this.inviteMsg = ''
				}else{
					this.$message({
						message:invite.msg,
						type:'warning'
					})
				}
			},
			async getUserLists(){
				const list = await this.$api.getUserLists({page_size:99999999})
				this.adminOptions = list.data.data
			},
			async getDepartmentList(){
				const list = await this.$api.getDepartmentList({company_id:this.groupInfo.id,type:2})
				this.DepartmentList = list.data
				if(list.data.length){
					this.adminValue = list.data[0].id
					this.getPositionList()
				}
			},
			// const list = await this.$api.addNewPosition({company_id:this.$store.state.companyInfo.id})
			async getPositionList(){
				const list = await this.$api.getPositionList({department_id:this.adminValue})
				this.positionList = list.data
			},
			async confirmAdd() {
				if(this.addNewDepart.name == ''){
					this.$message({
						message:'请输入岗位名称',
						type:'error'
					})
					return
				}
				this.addNewDepart.department_id = this.adminValue
				const add = await this.$api.addNewPosition({...this.addNewDepart})
				if(add.code == 1){
					this.$message({
						message:add.msg,
						type:'success'
					})
					this.addNew = false
					this.getDepartmentList()
				}else{
					this.$message({
						message:add.msg,
						type:'warning'
					})
				}
			},
			changeStatus(row) {
				this.statusDialogVisible = true
				this.statusID = row.id
				this.statusValue = row.status*1
			},
			async delUserFromJob(item){
				const del = await this.$api.delUserFromJob({id:item.id})
				if(del.code == 1){
					this.$message({
						message:del.msg,
						type:'success'
					})
					this.getPositionList()
				}else{
					this.$message({
						message:del.msg,
						type:'warning'
					})
				}
			},
			async statusConfirm() {
				const change = await this.$api.changeJobStatus({status:this.statusValue,id:this.statusID})
				if(change.code == 1){
					this.$message({
						message:change.msg,
						type:'success'
					})
					this.statusDialogVisible = false
					this.getPositionList()
				}else{
					this.$message({
						message:change.msg,
						type:'warning'
					})
				}
			},
			changeAdmin(row) {
				this.adminDialogVisible = true
				this.adminID = row.id
				this.adminValue = row.admin
			},
			userConfirm() {
				let obj = this.tableData3.find(obj => obj.id === this.adminID)
				obj.admin = this.adminValue
				this.userDialogVisible = false
			},

		}
	}
</script>

<style lang="less" scoped>
	.select {
		/deep/.el-input__inner {

			border: none;
			line-height: 45px;
			font-size: 18px;
			width: 150px;
			color: black !important;
			height: 45px;

		}
	}

	.form-item {
		display: flex;
		margin-bottom: 30px;
		align-items: baseline;

		/deep/.el-input__inner::placeholder {
			color: #999999;
		}

		/deep/.el-input__inner {
			width: 448px;
		}

		.inp {
			margin-left: 40px;

			& input {
				font-size: 18px;
				padding: 0 15px;
				box-sizing: border-box;
				width: 448px;
				height: 45px;
				border: 1px solid #D2D2D2;
				border-radius: 6px;
			}
		}

		.form-item-title {
			font-size: 18px;
			display: flex;
			align-items: center;

			&>div {
				width: 77px;
				text-align-last: justify;
			}
		}
	}

	/deep/.el-input__inner {

		border: 1px solid #D2D2D2;
		line-height: 45px;
		font-size: 18px;
		color: black !important;
		height: 45px;
		box-sizing: border-box;
	}

	.midlle-body {
		.addCompany {
			width: 261px;
			height: 40px;
			background: #0052D9;
			cursor: pointer;
			margin: auto;
			margin-top: 30px;
			color: white;
			line-height: 40px;
			text-align: center;
		}

		padding-bottom: 10px;

		/deep/.link {
			color: #0052D9;
			cursor: pointer;
			display: flex;
			justify-content: space-around;
		}

		padding-top: 20px;
		box-sizing: border-box;
		background: white;

		.body-title {
			color: #0052D9;
			display: flex;
			margin-bottom: 20px;
			font-weight: bold;
			font-size: 18px;

			.line {
				width: 4px;
				height: 22px;
				background: #0052D9;
			}
		}

		.loading {
			cursor: pointer;
			width: 116px;
			height: 40px;
			background: #F6F6F6;
			display: flex;
			align-items: center;
			margin: 10px;
			margin-bottom: 0;
			justify-content: center;
		}

	}

	.midlle {
		.myProject {
			width: 840px;
			padding: 20px 0;
			padding-top: 0;
			background: #FFFFFF;
		}

		width: 880px;
		padding: 0 20px;
		box-sizing: border-box;

		.title {
			display: flex;
			height: 40px;
			background: #E5EDFB;
			align-items: center;

			p {
				font-size: 14px;
				color: black;
				margin-left: 10px;

				span {
					color: #0052D9;
				}
			}

			.tit {
				display: inline-block;
				padding: 0 20px;
				background: #0052D9;
				height: 40px;
				line-height: 40px;
				color: white;
				font-size: 18px;
				border-radius: 0px 20px 20px 0px;
				font-weight: bold;
			}
		}
	}
</style>